//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sharedMethods from "../../../sharedMethods";
import DeleteMediaModal from "../DeleteMediaModal";
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";

export default {
  props: ["content"],
  components: {},

  data() {
    return {
      currentContent: null,
      contentGroup: null,
      carouselModel: [],
      rotateDisabled: false,
      flipDisabled: false,
      infoTT: false,
      isUsePl: [],
      hasDeviceControl: false,
    };
  },

  computed: {
    ...mapGetters(["getNextContent"]),
  },

  created() {
    this.hasDeviceControl = sharedMethods.hasFeature(2);
    if (!this.content.contentGroup) {
      this.currentContent = this.content.clone();
    } else {
      this.currentContent = this.content.contentGroup[0].clone();
      this.contentGroup = this.content.contentGroup;
      this.carouselModel = this.contentGroup.map((elem) => {
        return elem.id;
      });
    }
  },

  methods: {
    ...mapActions(["rotateContent", "flipContent", "updateContentInfo", "checkIfContentIsInAPlaylist"]),
    // Following methods are required in order to make the modal functionality work. Dont change them.
    // Modal function
    show() {
      this.$refs.dialog.show();
    },
    // Modal function
    hide() {
      this.$refs.dialog.hide();
    },
    // Modal function
    onDialogHide() {
      this.$emit("hide");
    },
    // Modal function
    onOKClick() {
      this.$emit("ok");
      this.hide();
    },
    // Modal function
    onCancelClick() {
      this.hide();
    },

    async saveChanges() {
      // Dectect changes, if none
      if (
        this.contentGroup &&
        _.isEqual(
          this.currentContent,
          this.contentGroup.find((c) => {
            return c.id === this.currentContent.id;
          })
        )
      ) {
        return false;
      } else if (_.isEqual(this.currentContent, this.content)) {
        return false;
      }

      const loading = sharedMethods.loadingNotify("Saving changes...");
      try {
        await this.updateContentInfo({
          contentId: this.currentContent.id,
          name: this.currentContent.name,
          src: this.currentContent.src,
          duration: this.currentContent.duration,
          productUrl: this.currentContent.productUrl,
        });
        loading();
        sharedMethods.successNotify("Changes saved sucessfully.");
      } catch (err) {
        loading();
        sharedMethods.errorNotify("An error occured saving your changes. Please try again later or open a ticket.");
      }
    },
    onContentChange(newContent) {
      this.currentContent = this.contentGroup
        .find((c) => {
          return c.id === newContent;
        })
        .clone();
    },

    onNext() {
      let nextContent;
      if (this.contentGroup) {
        nextContent = this.getNextContent(this.contentGroup);
      } else {
        nextContent = this.getNextContent(this.currentContent);
      }
      if (nextContent.contentGroupId) {
        this.currentContent = nextContent.contentGroup[0].clone();
        this.contentGroup = nextContent.contentGroup;
        this.carouselModel = nextContent.contentGroup.map((elem) => {
          return elem.id;
        });
      } else {
        this.currentContent = nextContent.clone();
        this.contentGroup = null;
        this.carouselModel = [];
      }
    },
    onPrev() {
      let nextContent;
      if (this.contentGroup) {
        nextContent = this.getNextContent(this.contentGroup, true);
      } else {
        nextContent = this.getNextContent(this.currentContent, true);
      }
      if (nextContent.contentGroupId) {
        this.currentContent = nextContent.contentGroup[0].clone();
        this.contentGroup = nextContent.contentGroup;
        this.carouselModel = nextContent.contentGroup.map((elem) => {
          return elem.id;
        });
      } else {
        this.currentContent = nextContent.clone();
        this.contentGroup = null;
        this.carouselModel = [];
      }
    },

    onDelete() {
      this.checkIfContentIsInAPlaylist([this.currentContent.id]).then((response) => {
        this.isUsePl = response.data;
        sharedMethods.createDialog({
          component: DeleteMediaModal,
          root: this,
          inUsePl: this.isUsePl,
          contentsToDelete: [this.currentContent],
          darkmode: true,
        });
      });
    },

    onFlip() {
      const loading = sharedMethods.loadingNotify("Flipping " + this.currentContent.name);
      this.flipDisabled = true;
      const flipInfo = {
        contentId: this.currentContent.id,
      };

      this.flipContent(flipInfo)
        .then(() => {
          // LOADING ANIMATION CANCEL
          loading();
          sharedMethods.successNotify("Flip complete. A horizontally inverted version is now in your library.");
        })
        .catch((err) => {
          this.rotateDisabled = false;
          // LOADING ANIMATION CANCEL
          loading();
          sharedMethods.errorNotify("Ooops. An error occured flipping your video. Please try again later or upload a flipped version from your computer.");
          console.log(err);
        });
    },

    onRotate() {
      const loading = sharedMethods.loadingNotify("Rotating please wait " + this.currentContent.name);
      this.rotateDisabled = true;
      let direction;

      if (this.currentContent.orientation === "LANDSCAPE") {
        direction = "PORTRAIT";
      } else {
        direction = "LANDSCAPE";
      }

      const rotateInfo = {
        contentId: this.currentContent.id,
        orientation: direction,
      };

      this.rotateContent(rotateInfo)
        .then(() => {
          caches.open("v1").then((cache) => {
            cache.delete(this.currentContent.src);
            cache.delete(this.currentContent.srcThumb);
            cache.delete(this.currentContent.srcPreview);
          });
          // LOADING ANIMATION CANCEL
          loading();
          sharedMethods.successNotify("Rotation complete. A rotated version is now in your library.");
        })
        .catch((err) => {
          this.rotateDisabled = false;
          // LOADING ANIMATION CANCEL
          loading();
          sharedMethods.errorNotify("Ooops. An error occured rotating your video. Please try again later or upload a rotated version from your computer.");
          console.log(err);
        });
    },

    onDownload() {
      sharedMethods.downloadContent(this.currentContent.id, this.currentContent.name);
    },

    formatDate(date) {
      return moment(String(date)).format("DD.MM.YYYY hh:mm");
    },

    onActionClick(action) {
      switch (action) {
        case "rename":
          this.actionRename();
          break;
        case "setDuration":
          this.actionSetDuration();
          break;
        case "setProductUrl":
          this.actionSetProductUrl();
          break;
        case "rotate":
          this.onRotate();
          break;
        case "flip":
          this.onFlip();
          break;
        case "download":
          this.onDownload();
          break;
        case "delete":
          this.onDelete();
          break;
        default:
          break;
      }
    },

    actionRename() {
      sharedMethods
        .createDialog({
          dark: true,
          color: "primary",
          title: "Name",
          message: "Enter new name",
          prompt: {
            model: this.currentContent.name,
            type: "text",
          },
          cancel: true,
          persistent: false,
        })
        .onOk((data) => {
          this.currentContent.name = data;
          this.saveChanges();
        });
    },

    actionSetDuration() {
      sharedMethods
        .createDialog({
          dark: true,
          title: "Duration",
          color: "primary",
          message: "Set new display time HH:MM:SS",
          prompt: {
            model: this.currentContent.duration,
            type: "time",
          },
          cancel: true,
          persistent: false,
        })
        .onOk((data) => {
          this.currentContent.duration = data;
          this.saveChanges();
        });
    },

    actionSetProductUrl() {
      sharedMethods
        .createDialog({
          dark: true,
          title: "Product URL",
          color: "primary",
          message: "Set the product URL which the content refers to.",
          prompt: {
            model: this.currentContent.productUrl,
            type: "text",
          },
          cancel: true,
          persistent: false,
        })
        .onOk((data) => {
          this.currentContent.productUrl = data;
          this.saveChanges();
        });
    },
  },
};
